// extracted by mini-css-extract-plugin
export default {"wrapper":"Flow_wrapper__kzTvy","flowWrapper":"Flow_flowWrapper__2qpi2"};